import { render, staticRenderFns } from "./LastScreen.vue?vue&type=template&id=7e2e6236&"
import script from "./LastScreen.vue?vue&type=script&lang=js&"
export * from "./LastScreen.vue?vue&type=script&lang=js&"
import style0 from "./LastScreen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports